
let src='http://test.xuexi.qsxueli.com:8980'
// src = 'http://192.168.1.79'
// src = 'https://404xuexi.test5184.com'    //线上测试请求
// src = 'https://xuexi.qsxueli.com'        //线上正式请求
// src = 'https://test.xuexi.qsxueli.com'   //本地请求
const serverSrc= src      //请求域名
export default {
    serverSrc
}


// WEBPACK FOOTER //
// ./src/local_request.js